import { getEntities } from "pages/api-clients/graph-search";
import { useEffect, useRef, useState } from "react";
import { usePagination } from "src/hooks/usePagination";
import { useApplicationContext } from "src/hooks/useApplication";
import { useQueryToasterErrors } from "src/hooks/useToaster";
import { SearchState, SearchWindow } from "../types";
import { useQuerySubscription } from "../../hooks/useQuerySubscription";

export function useEntitiesList({
  state,
  serialized,
}: {
  state: SearchState;
  serialized: string;
}) {
  const orgId = useApplicationContext().org_id!;
  const [window, setWindow] = useState<SearchWindow>({});
  const pagination = usePagination();
  const setPageRef = useRef(pagination.setPage);
  setPageRef.current = pagination.setPage;
  useEffect(() => setPageRef.current(1), [serialized]);
  const [pointer, setSerialized] = useState("");
  const { page, pageSize } = pagination;
  const queryKey = { state, window, page, pageSize, orgId };
  const { query, subscribe, unsubscribe } = useQuerySubscription(
    ["search/useEntitiesList", queryKey],
    async () => {
      setSerialized(serialized);
      return getEntities(state, page, pageSize, orgId, window);
    },
    {
      enabled: !Boolean(state.groupBys?.length),
    }
  );

  useQueryToasterErrors(query);

  return {
    ...query,
    ...pagination,
    subscribe,
    unsubscribe,
    serialized: pointer,
    window,
    setWindow,
  };
}
